import { request } from '~/components/Instance';

/**
 * API do módulo de Campanhas.
 *
 * Todas as respostas do backend vêm em { status, data } e o axios embrulha em
 * `data` de novo — daí o response.data.data que se repete no projeto inteiro.
 */
const unwrap = (response) => (response && response.data && response.data.data) || null;

export const listarCampanhas = () =>
  request('get', '/campaigns', {}, false).then(unwrap);

export const buscarCampanha = (id) =>
  request('get', '/campaigns/' + id, {}, false).then(unwrap);

export const listarTemplates = () =>
  request('get', '/campaigns/templates', {}, false).then(unwrap);

export const opcoesDeFiltro = () =>
  request('get', '/campaigns/audience/options', {}, false).then(unwrap);

/** Funil do público — recalculado a cada mudança de filtro na tela. */
export const previewPublico = (filters, source) =>
  request('post', '/campaigns/audience', { filters, source }, false).then(unwrap);

export const criarCampanha = (dados) =>
  request('post', '/campaigns', dados).then(unwrap);

export const salvarCampanha = (id, dados) =>
  request('post', '/campaigns/' + id, dados).then(unwrap);

export const removerCampanha = (id) =>
  request('delete', '/campaigns/' + id);

export const previewEmail = (id) =>
  request('get', '/campaigns/' + id + '/preview', {}, false).then(unwrap);

/**
 * Prévia enquanto se digita, sem salvar.
 *
 * A prévia por id só existe depois que a campanha foi gravada; esta compõe o
 * HTML no servidor a partir do que está na tela — é a mesma função que monta
 * o e-mail no envio, então o que se vê é o que sai.
 */
export const previewRascunho = (dados) =>
  request('post', '/campaigns/preview', dados, false).then(unwrap);

export const enviarTeste = (id, email) =>
  request('post', '/campaigns/' + id + '/test', { email });

/**
 * PDF do relatório.
 *
 * Vem por XHR e não por link direto: a rota exige o Bearer e o X-Tenant, e um
 * <a href> não manda cabeçalho nenhum — o download voltaria 401.
 */
export const baixarRelatorioPdf = (id) =>
  request('get', '/campaigns/' + id + '/report/pdf', {}, true, { responseType: 'blob' })
    .then((resposta) => resposta && resposta.data);

export const dispararCampanha = (id) =>
  request('post', '/campaigns/' + id + '/dispatch').then(unwrap);

export const relatorioCampanha = (id) =>
  request('get', '/campaigns/' + id + '/report', {}, false).then(unwrap);

export const listarDescadastros = (incluirReativados) =>
  request('get', '/campaigns/unsubscribes' + (incluirReativados ? '?incluir_reativados=1' : ''), {}, false).then(unwrap);

export const descadastrosDaCampanha = (id) =>
  request('get', '/campaigns/' + id + '/unsubscribes', {}, false).then(unwrap);

export const reativarDescadastro = (id) =>
  request('put', '/campaigns/unsubscribes/' + id + '/reactivate');

/**
 * Sobe imagem ou anexo. Vai como multipart, então o Content-Type é montado
 * pelo próprio navegador — definir na mão quebra o boundary.
 */
export const enviarArquivo = (arquivo, tipo) => {
  const dados = new FormData();
  dados.append('file', arquivo);
  dados.append('tipo', tipo || 'imagem');
  return request('post', '/campaigns/media', dados, false).then(unwrap);
};

export const removerArquivo = (caminho) =>
  request('delete', '/campaigns/media', { caminho }, false);

export const duplicarCampanha = (id) =>
  request('post', '/campaigns/' + id + '/duplicate').then(unwrap);

export const cancelarCampanha = (id) =>
  request('post', '/campaigns/' + id + '/cancel').then(unwrap);

/**
 * Agenda o disparo.
 *
 * A hora vai como texto de relógio de parede ('YYYY-MM-DD HH:mm:ss'), nunca
 * como ISO: `toISOString()` converte para UTC e o servidor, que compara em
 * horário de São Paulo, dispararia três horas fora do combinado.
 */
export const agendarCampanha = (id, quando) =>
  request('post', '/campaigns/' + id + '/schedule', {
    scheduled_at: quando.format('YYYY-MM-DD HH:mm:ss'),
  }).then(unwrap);

export const desagendarCampanha = (id) =>
  request('post', '/campaigns/' + id + '/unschedule').then(unwrap);
